import React, { useEffect } from 'react'

const Popup = (props) => {
    const { children, className, show, onHide } = props

    useEffect(() => {
        const close = (e) => {
            if (e.keyCode === 27) {
                onHide()
            }
        }
        window.addEventListener('keydown', close)
        return () => window.removeEventListener('keydown', close)
    }, [])

    return (
        <div className={`popup ${className} ${show ? 'show' : ''}`}>
            <div className="popup-modal-wrap">
                <div className="border-wrap">
                    <div className="popup-modal-content">
                        {children}
                    </div>
                </div>
            </div>
            <div
                onKeyPress={
                    (e) => {
                        if (e.key === 'Enter') {
                            showPopupModal()
                        }
                    }
                }
                onClick={onHide}
                className="popup-modal-overlay"></div>
        </div>
    )
}

export { Popup }
